module.exports = __webpack_public_path__ + "052644737f74513f897007db8d7f8e3e.jpg";